import { EnvironmentType } from './environment.types';

export const environment: EnvironmentType = {
  production: false,
  imports: [],
  providers: [],
  apiHost: 'https://api.suprema-stg.buildtec.com.br',
  mapTiles: {
    urlTemplate: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxZoom: 19,
  },
  trackerPlotAllPositions: false,
};
